import * as React from 'react';
import { Paper, StyleRulesCallback, WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { List } from '@material-ui/core';
import { ListItem } from '@material-ui/core';
import { ListItemText } from '@material-ui/core';
import moment from 'moment';
import PaginationNavigation from '../../PaginationNavigation';
import { Page } from '../../../api/pageable';
import { AnsweredQuestionnaireDto } from '../../../pages/answeredQuestionnaireTypes';
import { ListItemSecondaryAction } from '@material-ui/core';
import { observer } from 'mobx-react';
import AnsweredQuestionnaireListMenu from './AnsweredQuestionnaireListMenu';

interface Props {
  questionnaires: Page<AnsweredQuestionnaireDto>
  handleChangePage: (event: any, page: number) => void
  onClick: (questionnaireDto: AnsweredQuestionnaireDto) => void
  emptyPage: JSX.Element
  downloadButtonEnabled: boolean
}

type LocalStyles = 'root' | 'emptyContainer';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
  },
  emptyContainer: {
    padding: theme.spacing.unit * 4
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class AnsweredQuestionnaireList extends React.Component<PropsWithStyle> {

  public render() {
    return (
      <>
        {
          this.props.questionnaires.content.length === 0 ?
            this.props.emptyPage :
            <Paper elevation={1} className={this.props.classes.root}>
              <List>
                {this.props.questionnaires.content.map(questionnaire => (
                  <ListItem
                    key={questionnaire.id}
                    button={true}
                    onClick={
                      () => this.props.onClick(questionnaire)
                    }>
                    <ListItemText
                      primary={`${questionnaire.appraisee.firstName} ${questionnaire.appraisee.lastName}`}
                      secondary={`${moment(questionnaire.startDate).format('DD.MM.YYYY')}-${moment(questionnaire.endDate).format('DD.MM.YYYY')}`}
                    />
                    {
                      this.props.downloadButtonEnabled &&
                      <ListItemSecondaryAction>
                        <AnsweredQuestionnaireListMenu
                          questionnaire={questionnaire}
                        />
                      </ListItemSecondaryAction>
                    }
                  </ListItem>
                ))}
              </List>
              <PaginationNavigation
                totalPages={this.props.questionnaires.totalPages}
                page={this.props.questionnaires.pageable.pageNumber!!}
                onChangePage={this.props.handleChangePage}/>
            </Paper>
        }
      </>
    )
  }

}

export default withStyles(localStyles)(AnsweredQuestionnaireList);
